import axios from "axios"
import { getBaseApiUrl } from "../constant/Urls"

export const sendPost = async (url, body, baseUrl) => {
    var fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    try {
        setHeader()
        var response = await axios.post(fullUrl, body)
        return handleResponse(response)
    } catch (error) {
        return handleResponse(error.response)
    }
}

export const sendGet = async (url, baseUrl) => {
    var fullUrl

    if (url.includes("placeholder")) {
        fullUrl = "/placeholder-data/" + url.split("/")[1]
    } else {
        fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    }
    try {
        setHeader()
        var response = await axios.get(fullUrl)
        return handleResponse(response)
    } catch (error) {
        return handleResponse(error.response)
    }
}

export const sendGetFile = async (url, baseUrl) => {
    var fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    try {
        setHeader()
        var response = await axios.get(fullUrl, { responseType: "blob" })
        return response
    } catch (error) {
        return handleResponse(error.response)
    }
}

export const uploadFile = async (url, file, baseUrl) => {
    var fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    try {
        var formData = new FormData()
        formData.append("file", file)
        var response = await axios.post(fullUrl, formData)
        return handleResponse(response)
    } catch (error) {
        return handleResponse(error.response)
    }
}

export const uploadFiles = async (url, files, baseUrl) => {
    var fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    try {
        var formData = new FormData()
        // Append each file with its real name under the key "files"
        files.forEach((file, index) => {
            formData.append("files", file, file.name)
        })
        var response = await axios.post(fullUrl, formData)
        return handleResponse(response)
    } catch (error) {
        return handleResponse(error.response)
    }
}

export const sendPut = async (url, body, baseUrl) => {
    var fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    try {
        setHeader()
        var response = await axios.put(fullUrl, body)
        return handleResponse(response)
    } catch (error) {
        return handleResponse(error.response)
    }
}

export const sendDelete = async (url, body, baseUrl) => {
    var fullUrl = (baseUrl === undefined ? getBaseApiUrl() : baseUrl) + url
    try {
        setHeader()
        var response = await axios.delete(fullUrl, { data: body })
        return handleResponse(response)
    } catch (error) {
        return handleResponse(error.response)
    }
}

const setHeader = () => {
    const accessToken = sessionStorage.getItem("ACCESS_TOKEN")

    axios.defaults.withCredentials = false
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*"

    if (accessToken !== undefined) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
    }

    if (localStorage.getItem("devBypass")) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("devBypass")}`

        axios.defaults.headers.common["pid"] = localStorage.getItem("pid")
        axios.defaults.headers.common["epid"] = localStorage.getItem("epid")
        axios.defaults.headers.common["reverse"] = localStorage.getItem("reverse")
        axios.defaults.headers.common["euid"] = localStorage.getItem("euid")
        axios.defaults.headers.common["uid"] = localStorage.getItem("uid")
        axios.defaults.headers.common["custom"] = localStorage.getItem("custom")
        axios.defaults.headers.common["sid"] = localStorage.getItem("sid")
        axios.defaults.headers.common["csfid"] = localStorage.getItem("csfid")
        axios.defaults.headers.common["acc"] = localStorage.getItem("acc")
        axios.defaults.headers.common["crmacc"] = localStorage.getItem("crmacc")
        axios.defaults.headers.common["crmcon"] = localStorage.getItem("crmcon")
        axios.defaults.headers.common["crmopp"] = localStorage.getItem("crmopp")
        axios.defaults.headers.common["usid"] = localStorage.getItem("usid")
        axios.defaults.headers.common["gid"] = localStorage.getItem("gid")
        axios.defaults.headers.common["vcid"] = localStorage.getItem("vcid")
        axios.defaults.headers.common["MakeCopy"] = localStorage.getItem("MakeCopy")
        axios.defaults.headers.common["FromMyAssignments"] = localStorage.getItem("FromMyAssignments")
        axios.defaults.headers.common["cstype"] = localStorage.getItem("cstype")
        axios.defaults.headers.common["asgmtid"] = localStorage.getItem("asgmtid")
        axios.defaults.headers.common["accname"] = localStorage.getItem("accname")
        axios.defaults.headers.common["conname"] = localStorage.getItem("conname")
        axios.defaults.headers.common["oppname"] = localStorage.getItem("oppname")
        axios.defaults.headers.common["ptitle"] = localStorage.getItem("ptitle")
    }
}

// maps an axios response to a result
const handleResponse = (response) => {
    if (response.status === 200 || response.status === 204) {
        if (response.data === undefined) {
            return response
        }
        return response.data
    } else if (response.status === 401) {
        const ACCESS_TOKEN = window.sessionStorage.getItem("ACCESS_TOKEN")
        if (ACCESS_TOKEN) {
            window.sessionStorage.removeItem("site")
            window.sessionStorage.removeItem("ACCESS_TOKEN")
            window.sessionStorage.removeItem("REFRESH_TOKEN")
            if (!response?.request?.responseURL?.endsWith("/Accounts/Current")) {
                window.sessionStorage.setItem("sessionOut", true)
            }
            window.location.href = window.location?.pathname?.includes("/admin") ? "/admin/login" : "/agency/login"
        }
    }
}
